import type { SessionStepDto } from '../../schemas/sessionSchemas';

export function isLivenessStep(step: SessionStepDto) {
  const t = step.stepType.toLowerCase();
  if (t.includes('liveness')) return true;
  // Fall back to the display name only when the stepType clearly isn't another
  // category (the combined "Face & Liveness Check" name belongs to Face Match).
  if (t.includes('face') || t.includes('pan') || t.includes('aadhaar')) return false;
  return /liveness/i.test(step.displayName);
}
